import React from 'react';

export interface FilterFieldProps {
	label: string;
	htmlFor?: string;
	labelId?: string;
	helperText?: string;
	children: React.ReactNode;
}

export function FilterField({ label, htmlFor, labelId, helperText, children }: FilterFieldProps) {
	return (
		<div>
			<label
				id={labelId}
				className='block mb-1 text-labelsmall text-gray-500 leading-tight whitespace-nowrap truncate'
				htmlFor={htmlFor}
				title={label}
			>
				{label}
			</label>
			{children}
			{helperText ? <p className='mt-1 text-xs text-gray-400'>{helperText}</p> : null}
		</div>
	);
}
